var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkTrips = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 11,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#888",
  d: "M0 2.115A2.115 2.115 0 0 1 2.115 0H5.5a2.115 2.115 0 0 1 2.115 2.115v.423H6.77v-.423A1.27 1.27 0 0 0 5.5.846H2.115a1.27 1.27 0 0 0-1.269 1.27V5.5a1.27 1.27 0 0 0 1.27 1.27H6.84a1.27 1.27 0 1 1 0 .845H2.115A2.115 2.115 0 0 1 0 5.5zm4.23 6.347v.423A2.115 2.115 0 0 0 6.347 11h3.385a2.116 2.116 0 0 0 2.115-2.115V5.5a2.115 2.115 0 0 0-2.115-2.115H5.005a1.27 1.27 0 1 0 0 .846h4.726A1.27 1.27 0 0 1 11 5.5v3.385a1.27 1.27 0 0 1-1.27 1.269H6.347a1.27 1.27 0 0 1-1.27-1.27v-.422z"
})));
export default SvgLinkTrips;